module.exports = __webpack_public_path__ + "static/Orange and Grey Siding - Cladding-5bc6d49bc6bb45c6297587bdc0ac83f9.jpg";